import { Children } from 'react';
import type { OrderedListItemProps, OrderedListProps } from './types';

// Numbered steps with circular badges, derived from item order. The parent owns the numbering so an
// `OrderedList.Item` is just a content holder — drop it in and the badge follows.
export function OrderedList({ children }: OrderedListProps) {
  return (
    <ol className="m-0 flex list-none flex-col gap-3 p-0">
      {Children.map(children, (child, index) => (
        <li className="flex items-start gap-3 text-sm text-spark-text-primary">
          <span className="mt-px grid size-6 flex-none place-items-center rounded-full border border-gray-200 bg-white font-bold text-xs">
            {index + 1}
          </span>
          <span className="flex-1 pt-px">{child}</span>
        </li>
      ))}
    </ol>
  );
}

function OrderedListItem({ children }: OrderedListItemProps) {
  return <>{children}</>;
}

OrderedList.Item = OrderedListItem;
